import React, { useState } from 'react';
import InputRange from 'react-input-range';
import 'react-input-range/lib/css/index.css';
import './RangeInputStyles.css';

const RangeInput: React.FC<any> = ({ defaultValues, maxValue, minValue, onChange }) => {
  const [inputValue, setInputValue] = useState(defaultValues);
  return (
    <InputRange
      allowSameValues
      minValue={minValue}
      maxValue={maxValue}
      step={50}
      formatLabel={value => `${value}`}
      value={inputValue}
      onChange={(values: any) => {
        if (values.min < 0) {
          setInputValue({ min: 0, max: values.max });
        } else if (values.max > maxValue) {
          setInputValue({ min: values.min, max: maxValue });
        } else {
          setInputValue(values);
        }
        onChange(values);
      }}
    />
  );
};

export default RangeInput;
